import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';
import { useAuth } from '../../context/AuthContext';
import { Header } from './Header';
import { Sidebar, MobileSidebar } from './Sidebar';
import { AssistantWidget } from '../assistant/AssistantWidget';

export function DashboardLayout() {
  const { t } = useTranslation();
  const { assistantEnabled, entityType, entityId } = useAuth();
  // Below `sm` the assistant's launcher is a 48 px circle fixed bottom-right;
  // without this space it lies on the footer's legal links (ticket 21.4).
  const assistantShown = assistantEnabled && Boolean(entityType && entityId);

  return (
    // The assistant's *widget* lives in the cabinet layout only (ticket 21): one
    // instance, inside ProtectedRoute, lazy, and never on `/`, a public page or
    // /admin/dashboard — where there is no entity and therefore no principal.
    // Its conversation state lives in AppShell, above the Suspense boundary, so
    // a layout remount cannot throw the conversation away.
    <div className="min-h-screen bg-secondary flex flex-col">
      <Header />
      <div className="flex flex-1 min-h-[calc(100vh-4rem)]">
        <Sidebar />
        <MobileSidebar />
        <main className="flex-1 min-w-0 p-4 sm:p-6 lg:p-12 overflow-x-hidden flex flex-col">
          <div className="max-w-[1600px] flex-1">
            <Outlet />
          </div>
          {/* App footer (ticket 5): legal links on every authenticated page */}
          <footer
            className={cn(
              'max-w-[1600px] mt-10 pt-4 border-t border-border flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground',
              assistantShown && 'pb-16 sm:pb-0'
            )}
          >
            <span>© {new Date().getFullYear()} Unikort</span>
            <Link to="/terms" className="hover:text-foreground hover:underline">{t('legal.terms')}</Link>
            <Link to="/privacy" className="hover:text-foreground hover:underline">{t('legal.privacy')}</Link>
          </footer>
        </main>
      </div>
      <AssistantWidget />
    </div>
  );
}
